import request from '@/utils/request';
import CryptoJS from 'crypto-js';

// 固定 16 字节 key & iv
const AES_KEY_STR = 'thanks,pig4cloud';
const KEY = CryptoJS.enc.Utf8.parse(AES_KEY_STR);
const IV  = KEY;

// AES 加密（CFB + NoPadding）——简洁版
export function encryptPassword(plainText) {
  const data = CryptoJS.enc.Utf8.parse(plainText); // 明文转 WordArray
  const encrypted = CryptoJS.AES.encrypt(data, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding
  });
  return encrypted.toString(); // Base64
}

// （可选）解密，用于本地自测
export function decryptPassword(cipherBase64) {
  const decrypted = CryptoJS.AES.decrypt(cipherBase64, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding
  });
  return CryptoJS.enc.Utf8.stringify(decrypted);
}

// 调 OAuth2（把签名加密后当 password 传）
export function requestOAuthToken(address, signature,message) {
  const form = new URLSearchParams();
  form.append('username', address);
  form.append('password', encryptPassword(signature)); // Pig 密码加密
  form.append('grant_type', 'password');
  form.append('scope', 'server');
  form.append('rawSignature', signature);              // 供 bluex 分支校验
  form.append('message', message);
  

  return request.post('/admin/oauth2/token', form, {
    headers: { 'Authorization': 'Basic Ymx1ZXg6Ymx1ZXg=' }
  });
}
